import { createFileRoute } from "@tanstack/react-router";
import { Box } from "@mui/material";
import { Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/projects")({
  component: Layout,
});

function Layout() {
  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        overflow: "hidden",
      }}
    >
      {/* Main content area */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
